module.exports = __webpack_public_path__ + "media/images/support/geolocation/geolocation-edge-permission-2-f64912fc1f11da279860f5a25fafbbc4.png";